import { render, staticRenderFns } from "./quizs.vue?vue&type=template&id=79a0503f&"
import script from "./quizs.vue?vue&type=script&lang=js&"
export * from "./quizs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports